/**
 * Utility function to strip markdown formatting for clipboard copy
 * This is a simple implementation that could be replaced with a library like 'remove-markdown' if needed
 */
export const stripMarkdown = (markdown: string): string => {
  let text = markdown

  // Remove HTML tags
  text = text.replace(/<[^>]*>/g, '')

  // Remove headers (###, ##, #)
  text = text.replace(/^#{1,6}\s+/gm, '')

  // Remove bold/italic markers
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1')
  text = text.replace(/\*([^*]+)\*/g, '$1')
  text = text.replace(/__([^_]+)__/g, '$1')
  text = text.replace(/_([^_]+)_/g, '$1')

  // Remove code blocks
  text = text.replace(/```[^`]*```/g, '')
  text = text.replace(/`([^`]+)`/g, '$1')

  // Remove links but keep the text
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')

  // Remove list markers
  text = text.replace(/^\s*[-*+]\s+/gm, '')
  text = text.replace(/^\s*\d+\.\s+/gm, '')

  // Remove blockquotes
  text = text.replace(/^\s*>\s+/gm, '')

  // Remove horizontal rules
  text = text.replace(/^---+$/gm, '')

  // Remove extra whitespace and trim
  text = text.replace(/\n{3,}/g, '\n\n')
  text = text.trim()

  return text
}
